import { Routes } from "@angular/router";
import * as fromContainers from './containers';
import { QuotationPageResolver } from "./quotation-page.resolver";

export const ROUTES: Routes = [
    {
        path: '',
        component: fromContainers.QuotationComponent,
        resolve: {
            quotation: QuotationPageResolver
        }
    },
    {
        path: ':quotation',
        component: fromContainers.QuotationComponent,
        resolve: {
            quotation: QuotationPageResolver
        }
    }
];
